import type { HubPayload } from '../types'

/** Alinhado ao TTL do HubPayloadService (~45s). */
const SHELL_TTL_MS = 45_000

type ShellCache = {
  userId: number
  at: number
  data: HubPayload
}

let shellCache: ShellCache | null = null

export function peekHubShellCache(userId: number): HubPayload | null {
  if (!shellCache || shellCache.userId !== userId) return null
  if (Date.now() - shellCache.at > SHELL_TTL_MS) return null
  return shellCache.data
}

export function setHubShellCache(userId: number, data: HubPayload): void {
  if (userId < 1) return
  shellCache = { userId, at: Date.now(), data }
}

export function invalidateHubShellCache(): void {
  shellCache = null
}
